import * as React from "react";
const SvgSpeed1X20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      d: "M3.2 15.5h6.406v-1.56H7.34V4.865H5.766c-.21 1.05-1.155 1.845-2.505 1.98v1.26h2.31v5.835H3.2v1.56Zm8.552-8.835L10.702 7.7l2.49 2.565-2.505 2.565 1.035 1.05 2.505-2.565 2.52 2.565 1.02-1.05-2.505-2.565 2.505-2.58-1.05-1.02-2.49 2.55-2.475-2.55Z"
    })
  );
export default SvgSpeed1X20Px;
